import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { registrationRequest, registrationSuccess, registrationFailure } from '../reducers/login';
import { xapiRequest } from '../reducers/xapi';
import { API_LINK } from '../../constants';
import * as moment from 'moment';
const API = `${API_LINK}api/register`;

function* registrationFunctionAxios() {
 
  const state = yield select(fullState => fullState);
  
  const {
    email,
    password,
    firstname,
    lastname,
    programCode,
    telephone,
    birthdate,
    gender,
    employeeNo,
    race,
    language,
    identityNo,
    conTitleID,
    maidenName,
    disability,
    conSocioEconomicStatus,
    conCountryID,
    conRegion,
    conBranch,
    conProvinceID,
    conMunicipalAreaID,
    positionHeld,
    highestQualification,
    highestSchoolLevel,
   
    cell,
    socc,
    address,
    city,
    code,
    businessUnit,
    noYears,
  } = state.form.registration.values;
  
  const amLeader =  0;
  const dob = moment(state.form.registration.values.birthdate).format('YYYY-MM-DD')
  
  const response = yield call(() => {

    
    
    
    
    
    
    
    
    
    
    
    
    
    
    return axios({
      method: 'post',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      data: {
        conCountryID: conCountryID[0],
        conMunicipalAreaID: conMunicipalAreaID[0],
        conProvinceID: conProvinceID[0],
        conClientRegionID: conRegion[0],
        conClientBranchID: conBranch[0],
        conTitleID: conTitleID[0],
        conDisabilityStatusID: disability[0],
        gender: gender[0],
        highestQualification: highestQualification[0],
        highestSchoolLevel: highestSchoolLevel[0],
        conLanguageID: language[0],
        race: race[0],
        conSocioEconomicStatusID:  conSocioEconomicStatus[0],
        socc: socc[0],
        firstname: firstname,
        lastname: lastname,
        email: email,
        telephone: telephone,
        password: password,
        programCode: programCode,
        amLeader: amLeader,
        employeeNo: employeeNo !== null ? employeeNo : '',
        birthdate: dob,
        maidenName: maidenName !== null ? maidenName : '',
        identityNo: identityNo,
        positionHeld: positionHeld !== null ? positionHeld : '',
        cell: cell,
        address: address,
        city: city,
        code: code,
        businessUnit: businessUnit !== null ? businessUnit : '',
        noYears: noYears !== null ? noYears : '',
        platform: 'web'
      },
    });
  });
  
  return response;
}

function* workerRegistrationSaga() {
  try {
    const response = yield call(registrationFunctionAxios);
    const responseFromLogin = response.data;

    if (response.status === 200) {
      yield put(registrationSuccess(responseFromLogin));
     
    }

    if (response.status === 205) {
      yield put(registrationFailure('Email does not exist'));
    }
    if (response.status === 206) {
      yield put(registrationFailure(response.data));
    }
    if (response.status === 208) {
      yield put(registrationFailure(response.data));
    }
    if (response.status === 500) {
      yield put(registrationFailure(response.statusText));
    }
  } catch (error) {
    
    yield put(registrationFailure(error.error));
  }
}

export function* watcherRegistrationSaga() {
  yield takeLatest(registrationRequest().type, workerRegistrationSaga);
}
